import axios from "axios";

const BASE_API_URL = "/api/report";

//報告 service
//  報告是非同步生成的：建立後拿 reportID 輪詢，status 變 done 才有 content。
class ReportService {
  //R-1 建立報告（開始生成）
  create({ reportType, input }) {
    return axios.post(BASE_API_URL, { reportType, input });
  }

  //R-2 查詢單一報告
  get(reportID) {
    return axios.get(`${BASE_API_URL}/${reportID}`);
  }

  //R-3 我的報告列表
  list({ page = 1, size = 20, reportType } = {}) {
    return axios.get(BASE_API_URL, { params: { page, size, reportType } });
  }

  //R-4 報告收藏庫
  //  跟 R-3 的差別：R-3 照 report.userID 撈，撈不到訪客買的那些
  //  （它們的 userID 是 guest:<orderID>）。R-4 從訂單撈，userID 或 email
  //  兩者取其一，所以「先用訪客身分買、之後才註冊」的人也看得到。
  library() {
    return axios.get(`${BASE_API_URL}/library`);
  }

  //輪詢直到報告完成
  //  intervalMs 5 秒、上限 3 分鐘：生成約需 1-3 分鐘，太密集只是白打 API。
  //  回傳 report 物件（status 為 done 或 failed）；逾時則 throw。
  async waitUntilDone(reportID, { intervalMs = 5000, timeoutMs = 180000 } = {}) {
    const deadline = Date.now() + timeoutMs;

    while (Date.now() < deadline) {
      const res = await this.get(reportID);
      const report = res.data?.data?.report;
      if (report && (report.status === "done" || report.status === "failed")) {
        return report;
      }
      await new Promise((r) => setTimeout(r, intervalMs));
    }

    throw new Error("報告產生逾時，請稍後至「我的報告」查看");
  }
}

//單例：全站共用同一個實例，避免每個元件各自 new 一份
const reportService = new ReportService();
export default reportService;
